import { useState } from 'react'

import MuiButton from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'

import DeleteConfirmDialog from './deleteConfirmDialog'

const DeleteToolbar = ({ selectedIds }) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  const handleDeleteProspectsClick = () => {
    setDeleteDialogOpen(true)
  }

  return (
    <>
      <MuiButton
        size="small"
        startIcon={<DeleteIcon />}
        onClick={handleDeleteProspectsClick}
        disabled={!selectedIds.length}
      >
        Delete
      </MuiButton>
      <DeleteConfirmDialog open={deleteDialogOpen} setOpen={setDeleteDialogOpen} prospectIds={selectedIds} />
    </>
  )
}

export default DeleteToolbar
